import { useSelector } from "react-redux";
import { store } from "../store";
import { API_CONFIG } from "./constants/constant";
import http from "./http.service";
import { modeSelector } from "../store/selectors/app.selector";

const getAllPayee = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BENEFICIARY",
      requestId: "GET_ALL_BENE",
      mode: "AA",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.getAllPayee, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getBankDetails = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      module: "BENEFICIARY",
      requestId: "GET_BANK_DETAILS",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.getBankDetails, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getBranchDetails = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      module: "BENEFICIARY",
      requestId: "GET_BRANCH_DETAILS",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.ifscBranchDetails, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const addPayeeVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      module: "BENEFICIARY",
      requestId: "ADD_BENE_VERIFY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.addPayeeVerify, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const addPayeeConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      module: "BENEFICIARY",
      requestId: "ADD_BENE_CONFIRM",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.addPayeeConfirm, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const addInternationalPayeeVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      module: "BENEFICIARY",
      requestId: "ADD_INTERNATIONAL_BENE_VERIFY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.addInternatinalPayeeVerify,
      reqParams
    );
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const addInternationalPayeeConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      module: "BENEFICIARY",
      requestId: "ADD_INTERNATIONAL_BENE_CONFIRM",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.addInternatinalPayeeConfirm,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const transferOptions = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FUNDTRANSFER",
      requestId: "TRANSFER_OPTIONS",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.transferOptions, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const transactionHistory = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      module: "FUNDTRANSFER",
      requestId: "FUNDTRANSFER",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.transactionHistory, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const viewScheduledTransfers = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "SCHEDULED",
      module: "FUNDTRANSFER",
    };
    const response = await http.post(
      API_CONFIG.viewScheduledTransfers,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getIfscCode = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails, mode } = app;
    const reqParams = {
      ...data,
      module: "BENEFICIARY",
      requestId: "GET_IFSC",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.getIfscCode, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getFavouriteList = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "GET_FAV_BENE_LIST",
      module: "BENEFICIARY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.getFavouriteList, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const addFavouritePayee = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "ADD_FAV_BENE",
      module: "BENEFICIARY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.addFavouritePayee, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const addFavOwnAccount = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "ADD_ACCOUNT_FAV",
      module: "BENEFICIARY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.addFavOwnAccount, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const verifyDeletePayee = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "REMOVE_BENE_VERIFY",
      module: "BENEFICIARY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.deletePayee, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const deletePayeeConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "REMOVE_BENE_CONFIRM",
      module: "BENEFICIARY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.deletePayeeConfirm, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getWithinBankAccDetails = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "GETWITHINBANKACCDETAILS",
      module: "FUNDTRANSFER",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.getWithinBankAccDetails,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getPendingRecords = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "TRANSFERPENDINGRECORDS",
      module: "FUNDTRANSFER",
      profileId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.getPendingRecords, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getNACHMandateDetails = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "GET_NACH_DETAILS",
      profileId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.getNACHMandateDetails,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const nachMandate = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "NACH_MANDATE_UPDATE",
      profileId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.nachMandate, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const acctLienAddVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "ACCT_LIEN_INQUIRY",
      module: "ACCLIEN_ADD",
      profileId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.acctLienAddVerify, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const acctLienAddComfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "ACCT_LIEN_INQUIRY",
      module: "ACCLIEN_ADD",
      profileId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.acctLienAddComfirm, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const acctLienModifyVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "ACCT_LIEN_INQUIRY",
      module: "ACCLIEN_MODIFY",
      profileId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.acctLienModifyVerify,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const acctLienModifyComfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "ACCT_LIEN_INQUIRY",
      module: "ACCLIEN_MODIFY",
      profileId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.acctLienModifyComfirm,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const acctLienInq = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "ACCT_LIEN_INQUIRY",
      profileId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.acctLienInq, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const updatePayeeImage = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "UPDATE_BENE_IMAGE",
      module: "BENEFICIARY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.updatePayeeImage, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getPayeeImages = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "GET_BENE_IMAGE",
      module: "BENEFICIARY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.getPayeeImages, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const modifyPayeeVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      module: "BENEFICIARY",
      requestId: "MODIFY_BENE_VERIFY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.modifyPayeeVerify, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const modifyPayeeConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      module: "BENEFICIARY",
      requestId: "MODIFY_BENE_CONFIRM",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.modifyPayeeConfirm, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getAllCountryCodes = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      module: "BENEFICIARY",
      requestId: "GET_COUNTRY_CODES",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.getAllCountryCodes, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const removePayeeImage = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "REMOVE_BENE_IMAGE",
      module: "BENEFICIARY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.removePayeeImage, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const accountLookUp = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      module: "BENE",
      requestId: "LOOKUP",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.accountLookUp, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const modifyInternatinalPayeeVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      module: "BENEFICIARY",
      requestId: "MODIFY_INTERNATIONAL_BENE_VERIFY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.modifyInternatinalPayeeVerify,
      reqParams
    );
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const modifyInternatinalPayeeConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      module: "BENEFICIARY",
      requestId: "MODIFY_INTERNATIONAL_BENE_CONFIRM",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.modifyInternatinalPayeeConfirm,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const SendMoneyService = {
  getAllPayee,
  getBankDetails,
  getBranchDetails,
  addPayeeVerify,
  addPayeeConfirm,
  transferOptions,
  transactionHistory,
  getIfscCode,
  getFavouriteList,
  addFavouritePayee,
  addFavOwnAccount,
  verifyDeletePayee,
  deletePayeeConfirm,
  viewScheduledTransfers,
  getWithinBankAccDetails,
  getPendingRecords,
  getNACHMandateDetails,
  nachMandate,
  acctLienAddComfirm,
  acctLienAddVerify,
  acctLienModifyComfirm,
  acctLienModifyVerify,
  acctLienInq,
  updatePayeeImage,
  getPayeeImages,
  modifyPayeeVerify,
  modifyPayeeConfirm,
  getAllCountryCodes,
  removePayeeImage,
  addInternationalPayeeVerify,
  addInternationalPayeeConfirm,
  accountLookUp,
  modifyInternatinalPayeeVerify,
  modifyInternatinalPayeeConfirm,
};

export default SendMoneyService;
